export { default as Header } from "./Header";
export { default as Main } from "./Main";
export { default as Footer } from "./Footer";
export { default as Nav } from "./Nav";